<template>
  <div style="padding-top:64px">
    <el-row style="margin: 50px 0">
      <el-col :span="24">
        <div class="sub_title">欢迎来到天人厌氧子平台</div>
        <div class="sub_title">请问您需要咨询什么信息？</div>
      </el-col>
    </el-row>
    <!--第一行-->
    <div style="display:flex;justify-content: center;">
      <div class="sub_img">
        <el-row>
          <el-col :xs="24" :sm="6" class="sub_img_col"  @click.native="login(imgList.sj[1],true,true)">
            <el-image
              :src="imgList.sj[0]"
              fit="fill"></el-image>
            <div class="sub_text">{{imgList.sj[2]}}</div>
          </el-col>
          <el-col :xs="24" :sm="0">
            <el-row type="flex" justify="center">
              <el-col :span="6">
                <el-image
                  :src="img_arrow"
                  class="sub_down_arrow"
                  fit="fill"></el-image>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="0" :sm="3">
            <el-image
              :src="img_arrow"
              fit="fill"></el-image>
          </el-col>
          <el-col :xs="24" :sm="6" class="sub_img_col" @click.native="login(imgList.cg[1],true,true)">
            <el-image
              :src="imgList.cg[0]"
              fit="fill"></el-image>
            <div class="sub_text" style="margin-top: 8px;">{{imgList.cg[2]}}</div>
          </el-col>
          <el-col :xs="24" :sm="0">
            <el-row type="flex" justify="center">
              <el-col :span="6">
                <el-image
                  :src="img_arrow"
                  class="sub_down_arrow"
                  fit="fill"></el-image>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="0" :sm="3">
            <el-image
              :src="img_arrow"
              fit="fill"></el-image>
          </el-col>
          <el-col :xs="24" :sm="6" class="sub_img_col" @click.native="login(imgList.cw[1],true,true)">
            <el-image
              :src="imgList.cw[0]"
              fit="fill"></el-image>
            <div class="sub_text" style="margin-top: 23px;">{{imgList.cw[2]}}</div>
          </el-col>
          <el-col :xs="24" :sm="0">
            <el-row type="flex" justify="center">
              <el-col :span="6">
                <el-image
                  :src="img_arrow"
                  class="sub_down_arrow"
                  fit="fill"></el-image>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <!--第二行-箭头-->
        <el-row>
          <el-col :xs="0" :sm="21"><div>&nbsp;</div></el-col>
          <el-col :xs="0" :sm="3">
            <el-image
              :src="img_arrow"
              class="sub_down_arrow"
              fit="fill"></el-image>
          </el-col>
        </el-row>

         <!--第三行-->
        <el-row style="margin-bottom: 50px">
          <el-col :xs="24" :sm="6" class="sub_img_col" @click.native="login(imgList.gk[1],true,true)">
            <el-image
              :src="imgList.gk[0]"
              fit="fill"></el-image>
            <div class="sub_text">{{imgList.gk[2]}}</div>
          </el-col>
          <el-col :xs="24" :sm="0">
            <el-row type="flex" justify="center">
              <el-col :span="6">
                <el-image
                  :src="img_arrow"
                  class="sub_down_arrow"
                  fit="fill"></el-image>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="0" :sm="3">
            <el-image
              :src="img_arrow"
              class="sub_left_arrow"
              fit="fill"></el-image>
          </el-col>
          <el-col :xs="24" :sm="6" class="sub_img_col" @click.native="login(imgList.sy[1],true,true)">
            <el-image
              :src="imgList.sy[0]"
              fit="fill"></el-image>
            <div class="sub_text">{{imgList.sy[2]}}</div>
          </el-col>
          <el-col :xs="24" :sm="0">
            <el-row type="flex" justify="center">
              <el-col :span="6">
                <el-image
                  :src="img_arrow"
                  class="sub_down_arrow"
                  fit="fill"></el-image>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="0" :sm="3">
            <el-image
              class="sub_left_arrow"
              :src="img_arrow"
              fit="fill"></el-image>
          </el-col>
          <el-col :xs="24" :sm="6" class="sub_img_col" @click.native="login(imgList.sg[1],true,true)">
            <el-image
              :src="imgList.sg[0]"
              fit="fill"></el-image>
            <div class="sub_text">{{imgList.sg[2]}}</div>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>

<script>
  import {login} from "@/api/home.js";
export default {
  name: 'AnSubPlatform',
  created() {
    this.order = this.$route.query.id;
  },
  data() {
    return {
      order: 0,
      img_arrow: '/api/jz/file/download/pt-eiiplat-lcdt/动态箭头.gif',
      imgList: {
        "sj":['/api/jz/file/download/pt-eiiplat-lcdt/设计-压缩.png',7,'项目设计'],
        "cg":['/api/jz/file/download/pt-eiiplat-lcdt/采购-压缩.png',8,'设备采购'],
        "sy":['/api/jz/file/download/pt-eiiplat-lcdt/收运-压缩.png',1,'原料收运'],
        "cw":['/api/jz/file/download/pt-eiiplat-lcdt/财务-压缩.png',13,'财务税收'],
        "sg":['/api/jz/file/download/pt-eiiplat-lcdt/施工-压缩.png',9,'项目施工'],
        "gk":['/api/jz/file/download/pt-eiiplat-lcdt/管控-压缩.png',3,'生产管控'],
      }
    }
  },
  methods: {
    login(index, status,forceOpen) {
      login(index, status,forceOpen);
    },
  }
}
</script>
<style lang="scss">
.sub_title{
  text-align: center;
  width: 100%;
/*  border: 1px solid red;*/
  font-size: 30px;
}
  .sub_text{
    text-align: center;
    width: 100%;
    font-size: 20px;
  }
  .sub_down_arrow
  {
    -moz-transform:rotate(90deg);
    -webkit-transform:rotate(90deg);
    filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1);

  }
  .sub_left_arrow
  {
    -moz-transform:rotate(180deg);
    -webkit-transform:rotate(180deg);
    filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  }
  .sub_img
  {
    // margin: 0px 180px;
    width: 75%;
  }
  .sub_img_col{
    cursor:pointer;
    border: 1px solid gray;
    margin-top: 10px;
  }

  .sub_img_col:hover{
    /*border:3px solid gray;*/
    box-shadow: 10px 10px 5px #888888;
  }

</style>



// WEBPACK FOOTER //
// src/components/AnSubPlatform.vue